import { ReactNode } from "react";
import { Box } from "@mui/material";
import "../../components-styles.scss";
import "../../Dossiers/Dossier/dossier-styles.scss";
import DocumentsLayoutHeader from "./DocumentsLayoutHeader";
import { TabMenu } from "@/src/types";

type DocumentsProps = {
    children: ReactNode;
    headerTitle: string;
    numberOfDocs: number;
    setActiveTab: Function;
    tabsMenu: TabMenu[];
    activeTab: string;
};

export default function DocumentsLayout({
    children,
    headerTitle,
    numberOfDocs,
    setActiveTab,
    tabsMenu,
    activeTab,
}: DocumentsProps) {
    return (
        <>
            <header className="dossier-header">
                <DocumentsLayoutHeader
                    headerTitle={headerTitle}
                    numberOfDocs={numberOfDocs}
                    setActiveTab={setActiveTab}
                    tabsMenu={tabsMenu}
                    activeTab={activeTab}
                />
            </header>
            <main className="layout-body" style={{ overflow: "hidden" }}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "3rem",
                        marginLeft: "6rem",
                        marginRight: "6rem",
                        marginTop: "2rem",
                        width: "100%",
                        "@media (max-width:1024px)": {
                            marginLeft: "1.5rem",
                            marginRight: "1.5rem",
                            width: "100vh",
                        },
                        "@media (min-width: 600px) and (max-width:1024px)": {
                            width: "100vw",
                        },
                    }}
                >
                    {children}
                </Box>
            </main>
        </>
    );
}
